import { uniqueId } from 'js/utils/methods.util';
import { send } from 'server';

export const getBalanceBreakdown = () => send({
    ID: 35506,
    responses: [35507, 35509],
    description: 'Get Balance Breakdown',
    balanceType: 'casino_gaming_balance'
});

export const getBonusDetails = referenceId => send({
    ID: 31118,
    responses: [31119, 31120],
    description: 'get bonus details',
    correlationId: uniqueId('bonus-details-'),
    bonusInstanceCode: referenceId,
    returnBonusTemplateDetails: true,
    returnWageringCoefficients: false,
    returnGamingContexts: true
});
